import { forwardRef } from 'react';

import { IconButton } from '@mui/material';
import { IconButtonProps } from '@mui/material/IconButton/IconButton';
import { DragIndicator } from '@mui/icons-material';

export interface HandleProps extends IconButtonProps {}

const noPointer = { cursor: 'grab' };

export const Handle = forwardRef<HTMLButtonElement, HandleProps>(
  (props, ref) => {
    return (
      <IconButton ref={ref} aria-label="handle" style={noPointer} {...props}>
        <DragIndicator />
      </IconButton>
    );
  },
);
